<template>
	<div class="tablelist">
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: 'tablelist'
	}
</script>



// WEBPACK FOOTER //
// src/components/tablelist/tablelist.vue